// @flow

import Service from './service';

export default class ContentfulService extends Service {
  getEntryById(id: string, locale: string = 'en-US') {
    return this.api
      .get(`${this.baseUrl}/content/entry/${id}?locale=${locale}`)
      .then(res => res.data);
  }

  getEntriesByType(type: string, params: Object = {}) {
    return this.api
      .get(`${this.baseUrl}/content/type/${type}`, { params })
      .then(res => res.data);
  }

  getStateConfig(stateCode: string) {
    return this.api
      .get(`${this.baseUrl}/content/state/${stateCode.toUpperCase()}`, {
        cache: true,
      })
      .then(res => res.data);
  }
}
